import store from "../../../../../app/store";

const savePromt = async (botId, prompt) => {
  const serverDomain = process.env.REACT_APP_SERVER;
  const url = `${serverDomain}/bot/prompt/${botId}`;
  const token = store.getState().auth.token;

  if (!token) {
    return {
      data: null,
      error: true,
      msg: "Authentication failed. Please login again.",
    };
  }

  const option = {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ prompt }),
  };

  try {
    const res = await fetch(url, option);

    if (!res.ok) {
      return {
        data: null,
        error: true,
        msg: "Failed to update prompt. Please try again.",
      };
    }

    const data = await res.json();
    return { data, error: false, msg: "Prompt updated successfully." };
  } catch (err) {
    return {
      data: null,
      error: true,
      msg: "Server error. Please check your connection and try again.",
    };
  }
};

export default savePromt;
